import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=b8481972"
import script from "./RegisterDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=b8481972&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports